/*  ==========================================================================
    CONTENTCLUSTER LOADER
    Helper to load contentcluster data easy and fast.

    INFO:
    - For help with the contentcluster you can look here:
      "https://brandnamic.atlassian.net/wiki/spaces/BNDOC/pages/297336833/Content+Cluster"
    ========================================================================== */

/*
 * IMPORTS
 */

// node modules imports
import $ from 'jquery';

// local imports
import * as vars from '../../globals/variables';

/*
 * CONTENTCLUSER LOADER
 */

// initialization
export function initCcService(container, callback) {
    let $loader = container.find('.bn-loader'),
        $noResult = container.find('.bn-no-result'),
        dataArray = container.data(),
        paramsString = '';

    // get configs
    $.each(dataArray, function(dataName, dataValue) {

        // config of ajax-content
        if (dataName.substr(0, 3) == 'ac_') {
            paramsString = paramsString + '&' + dataName.substring(3) + '=' + dataValue;
        }

        // config of contentcluster
        if (dataName.substr(0, 3) == 'cc_') {
            paramsString = paramsString + '&tx_bntypodist_cluster[' + dataName.substring(3) + ']=' + dataValue;
        }

    });

    // ajax call
    if(paramsString !== '') {
        let generatedLink = '/index.php?type=1&L=' + vars.lang_id + paramsString;
        $.ajax({
            dataType: 'html',
            cache: true,
            url: generatedLink + '&cacheBuster=' + vars.cacheBuster
        }).done(function(data) {

            // remove no result info and loader
            $loader.remove();
            $noResult.remove();

            // data log (only if user is logged in typo3)
            if(vars.$body.hasClass('be-user')) {
                console.log('');
                console.log('----------------------------------------------------------------------------------------------------');
                console.log('CONTENTCLUSTER:');
                console.log(dataArray);
                console.log('----------------------------------------------------------------------------------------------------');
                console.log('');
            }

            // insert data
            container.append(data);

            // callback
            if(callback) {
                callback(container);
            }

        });
    } else {

        // show no result info and remove loader
        $loader.remove();
        $noResult.removeClass('hidden');

    }

}



// WEBPACK FOOTER //
// ./source/js/utilities/lib/contentcluster-loader.js